import { gql } from '@apollo/client';

export const AUTHORIZE_QUICKBOOKS = gql`
  mutation AuthorizeQuickbooks(
    $code: String!
    $realmId: String!
  ) {
    authorizeQuickbooks(
      code: $code
      realmId: $realmId
    ) {
      user {
        quickbooksHasToken
      }
    }
  }
`;
